import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-13a188ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer knitBandModal" }
const _hoisted_2 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "variantToolbar mt-3 mb-4" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "variantNumber" }
const _hoisted_11 = { class: "variantDescription" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "col-sm-4" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = {
  class: "input_title",
  for: "knitBandFabricWeight"
}
const _hoisted_23 = {
  id: "knitBandFabricWeight",
  class: "d-block mt-3 calculatedWeight"
}
const _hoisted_24 = {
  key: 0,
  class: "text-muted ms-2"
}
const _hoisted_25 = { class: "d-flex align-items-end mb-3" }
const _hoisted_26 = { class: "flex-grow-1 me-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "me-2 percentageInput" }
const _hoisted_30 = { class: "d-block fs_14 fw_700 mb-1" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "table table-striped" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { colspan: "3" }
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "configurationSummary mb-4" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.globalErrors.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalErrors, (message, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Knit band",
          text: "Knit band"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bands, (band, index) => {
          return (_openBlock(), _createElementBlock("button", {
            type: "button",
            key: index,
            class: _normalizeClass(["variantCard", { active: _ctx.activeBandIndex == index, invalid: !_ctx.bandIsValid(band) }]),
            onClick: ($event: any) => (_ctx.selectBand(index))
          }, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(index + 1), 1),
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("strong", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Knit band",
                  text: "Knit band"
                }),
                _createTextVNode(" " + _toDisplayString(index + 1), 1)
              ]),
              _createElementVNode("small", null, "×" + _toDisplayString(band.quantity || 0) + " · " + _toDisplayString(band.bandFlatWidthCm || 0) + " × " + _toDisplayString(band.bandFlatLengthCm || 0) + " cm", 1)
            ])
          ], 10, _hoisted_9))
        }), 128)),
        _createElementVNode("button", {
          type: "button",
          class: "addVariantButton",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addBand && _ctx.addBand(...args)))
        }, [
          _hoisted_12,
          _createVNode(_component_localized_text, {
            localizedKey: "Add another composition",
            text: "Add another composition"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h4", _hoisted_14, [
          _createVNode(_component_localized_text, {
            localizedKey: "Composition",
            text: "Composition"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.activeBandIndex + 1), 1)
        ]),
        (_ctx.bands.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-danger btn-sm",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeBand && _ctx.removeBand(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Remove composition",
                text: "Remove composition"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.activeBand)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Quantity",
                labelValue: "Quantity",
                placeholderKey: "Quantity",
                placeholderValue: "Quantity",
                min: "1",
                step: "1",
                modelValue: _ctx.activeBand.quantity,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeBand.quantity) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Band flat width (cm)",
                labelValue: "Band flat width (cm)",
                placeholderKey: "Band flat width (cm)",
                placeholderValue: "Band flat width (cm)",
                min: "0",
                modelValue: _ctx.activeBand.bandFlatWidthCm,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeBand.bandFlatWidthCm) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Band flat length (unrolled) (cm)",
                labelValue: "Band flat length (unrolled) (cm)",
                placeholderKey: "Band flat length (unrolled) (cm)",
                placeholderValue: "Band flat length (unrolled) (cm)",
                min: "0",
                modelValue: _ctx.activeBand.bandFlatLengthCm,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeBand.bandFlatLengthCm) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_form_field, {
                type: "number",
                labelKey: "Fabric weight (GSM) (g/m²)",
                labelValue: "Fabric weight (GSM) (g/m²)",
                placeholderKey: "Fabric weight (GSM) (g/m²)",
                placeholderValue: "Fabric weight (GSM) (g/m²)",
                min: "0",
                modelValue: _ctx.activeBand.fabricGsm,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeBand.fabricGsm) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Fabric weight used (g)",
                    text: "Fabric weight used (g)",
                    class: "fev_text5 fw_600"
                  })
                ]),
                _createElementVNode("output", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.formattedWeight) + " g ", 1),
                  (Number(_ctx.activeBand.quantity) > 1)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_24, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.formattedTotalWeight) + " g ", 1),
                        _createVNode(_component_localized_text, {
                          localizedKey: "in total",
                          text: "in total"
                        }),
                        _createTextVNode(") ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_localized_text, {
            localizedKey: "Material",
            text: "Material",
            class: "d-block fs_14 fw_700 mb-1"
          }),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tempMaterialIdentifier) = $event))
          }, [
            _hoisted_27,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectableMaterials, (material) => {
              return (_openBlock(), _createElementBlock("option", {
                key: material.identifier,
                value: material.identifier
              }, _toDisplayString(material.materialName), 9, _hoisted_28))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.tempMaterialIdentifier]
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, [
            _createVNode(_component_localized_text, {
              localizedKey: "Percentage",
              text: "Percentage",
              class: "me-1"
            }),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.remainingPercentage > 0 ? 'text-danger' : 'text-success')
            }, " (" + _toDisplayString(_ctx.remainingPercentage.toFixed(2)) + "%) ", 3)
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            step: "0.01",
            min: "0",
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tempPercentage) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.tempPercentage,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          disabled: _ctx.addDisabled,
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addMaterial && _ctx.addMaterial(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add",
            text: "Add"
          })
        ], 8, _hoisted_31)
      ]),
      _createElementVNode("table", _hoisted_32, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Material",
                text: "Material"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Percentage",
                text: "Percentage"
              })
            ]),
            _hoisted_33
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.materials.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                _createElementVNode("td", _hoisted_35, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "No Elements Found",
                    text: "No Elements Found"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.materialIdentifier || item.materialName
            }, [
              _createElementVNode("td", null, _toDisplayString(item.materialName), 1),
              _createElementVNode("td", null, _toDisplayString(Number(item.percentage).toFixed(2)) + "%", 1),
              _createElementVNode("td", _hoisted_36, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger btn-sm",
                  onClick: ($event: any) => (_ctx.removeMaterial(index))
                }, "x", 8, _hoisted_37)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["fw_700 mb-4", _ctx.compositionIsValid ? 'text-success' : 'text-danger'])
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Total",
          text: "Total",
          class: "me-1"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.totalPercentage.toFixed(2)) + "% ", 1)
      ], 2),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("span", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Compositions",
            text: "Compositions"
          }),
          _createTextVNode(": "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.bands.length), 1)
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Total knit bands",
            text: "Total knit bands"
          }),
          _createTextVNode(": "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.totalQuantity), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: !_ctx.isValid,
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_40)
      ])
    ])
  ]))
}